'use client';

import { lazy, Suspense } from 'react';
import MyPopTopicHeader from '@fe-news/components/organisms/MyPopTopicHeader';
import LoginModal from '@fe-news/components/molecules/LoginModal';
import { useMyPopTopic } from '@fe-news/context/my-pop-topic-provider';
import MyPopTopicContentSkeleton from '@fe-news/components/organisms/MyPopTopicContent/MyPopTopicContentSkeleton';
import MyTagHeaderSkeleton from '@fe-news/components/organisms/MyTagHeader/MyTagHeaderSkeleton';

const MyPopTopicContent = lazy(() => import('@fe-news/components/organisms/MyPopTopicContent'));

type MyPopTopicProps = {
  children: React.ReactNode;
};

const MyPopTopic = ({ children }: MyPopTopicProps) => {
  const { isCloseLoginModal, onClickLoginModalClose } = useMyPopTopic();

  return (
    <Suspense
      fallback={
        <>
          <MyTagHeaderSkeleton />
          <MyPopTopicContentSkeleton />
        </>
      }
    >
      <LoginModal isModalClosed={isCloseLoginModal} onClickModalClose={onClickLoginModalClose} />
      <MyPopTopicHeader />
      <MyPopTopicContent>{children}</MyPopTopicContent>
    </Suspense>
  );
};

export default MyPopTopic;
